/**
 * 找到当前页面的多级筛选组件，给它添加属性，控制其渲染方式
 * 给当前按钮初始化点击事件，控制导航菜单的显示
 */

import { findCurrentComponentPathInLayoutByRectId } from "@/utils"
class AppMultiFilterDrawer {
  constructor(vue) {
    this.context = vue
    this.request_prefix = this.context.request_prefix
  }

  init() {
    // 该按钮插件只能在移动端中使用
    if (this.request_prefix !== "appStage") return

    // 找到当前页面的导航菜单组件
    const rectAttr = this.context.$store.state[this.request_prefix].page.children[0].children.find(
      rect => rect.shape === "cxMultiFilter"
    )

    if (!rectAttr) return

    // 找到当前页面的导航菜单组件所在的通栏
    const layout = this.context.$store.state[this.request_prefix].page.pageLayoutList
    const path = findCurrentComponentPathInLayoutByRectId(layout, rectAttr.rect_id).join("_")

    const drawerParams = {
      isDrawerMode: true,
      direction: "btt",
      drawer: false,
    }

    this.context.$changeOptionsEV(drawerParams, "drawerParams", false, null, {
      pageLayoutId: path
    })

    // 需要找到当前通栏的父级，并将其pageType置为空
    const parentPath = path.split("_")[0]
    this.context.$changeOptionsEV("relative", "positionType", false, null, {
      pageLayoutId: parentPath
    })
    this.context.$changeOptionsEV(path, "correlationLayoutId", false, null, {
      container_id: this.context.myid.container_id,
      rect_id: this.context.myid.rect_id
    })

    console.log("this.context.$el", this.context.$el)
  }

}

export default {
  methods: {
    appMultiFilterDrawerPlugin() {
      const appMultiFilterDrawer = new AppMultiFilterDrawer(this)
      appMultiFilterDrawer.init()
    },
  },
}
